module.exports = __webpack_public_path__ + "static/img/add-word.e8e8c86f.png";